class ShowIf {
	validators = {
		checked: target => {
			return !!target.checked;
		},
		value: (target, value) => {
			return target.value === value;
		}
	};

	constructor(el) {
		this.el = el;
		const rawCondition = el.getAttribute('data-show-if');
		const [targetId, condition, ...params] = rawCondition.split(':');
		this.target = document.getElementById(targetId);
		this.condition = condition;
		this.params = params;
		this.attachHandlers();
	}

	attachHandlers = () => {
		this.target.addEventListener('change', this.determineVisibility); // Handles IE - it doesn't recognise input on input[type=checkbox]
		this.target.addEventListener('input', this.determineVisibility);
		this.target.addEventListener('deselect', this.determineVisibility); // Add listener for custom 'deselect' event added above
		this.determineVisibility();
	};

	determineVisibility = () => {
		if (!this.validators.hasOwnProperty(this.condition)) {
			console.error('NO VALIDATION FOUND FOR', this.condition);
			return;
		}
		if (this.validators[this.condition](this.target, ...this.params)) {
			this.show();
		} else {
			this.hide();
		}
	};

	show = () => {
		this.el.style.display = '';
	};

	hide = () => {
		this.el.style.display = 'none';
	};
}

const els = Array.from(document.querySelectorAll('[data-show-if]'));
els.forEach(el => {
	new ShowIf(el);
});
